import { createStandardAction } from 'typesafe-actions';
import { FeedEventData } from '@tradingblock/types';

export const FEED_CLOSED = `@quotes/feed/closed`;
export const FEED_ERRORED = `@quotes/feed/errored`;
export const FEED_CONNECTED = `@quotes/feed/connected`;
export const feedClosed = createStandardAction(FEED_CLOSED)<FeedEventData>();
export const feedErrored = createStandardAction(FEED_ERRORED)<FeedEventData>();
export const feedConnected = createStandardAction(FEED_CONNECTED)();

export const QuotesFeedActions = {
  quotesFeedClosed: createStandardAction(FEED_CLOSED)<FeedEventData>(),
  quotesFeedErrored: createStandardAction(FEED_ERRORED)<FeedEventData>(),
  quotesFeedConnected: createStandardAction(FEED_CONNECTED)(),
};
